<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-text-field
      outlined
      label="Date d'accès *"
      v-model="access.dateIn"
      :rules="validation.dateIn"
      v-mask="['##.##.####']"
      hint="Format attendu JJ.MM.AAAA"
      dense
    />
    <v-text-field
      outlined
      label="Heure d'accès *"
      v-model="access.timeIn"
      :rules="validation.timeIn"
      v-mask="['##:##']"
      hint="Format attendu HH:MM"
      dense
    />
    <v-text-field
      type="number"
      outlined
      label="Durée en heures *"
      v-model="access.duration"
      :rules="validation.duration"
      v-mask="['##']"
      max="24"
      min="0"
      dense
    />
    <v-select
      dense
      outlined
      :label="unities.labels[type]"
      v-model="access.unity"
      :items="unities[type]"
    ></v-select>
    <v-text-field
      outlined
      label="Personne qui effectue la demande *"
      v-model="access.requesterEmail"
      dense
      disabled
    />
    <v-autocomplete
      v-model="access.managerEmail"
      :items="managers"
      :search-input.sync="searchManagers"
      label="Directeur d’Institut ou Supérieur hiérarchique *"
      outlined
      dense
      @input="clearSearchManagers"
      no-data-text="Tapez le nom d'une personne..."
    />
    <v-textarea
      dense
      outlined
      label="Motif de la demande *"
      v-model="access.reason"
      rows="3"
      auto-grow
      required
    ></v-textarea>
    <v-snackbar v-model="snackbar.visible" :bottom="true" :left="true" :color="snackbar.color">
      {{snackbar.text}}
      <v-btn dark text @click="snackbar.visible = false">Fermer</v-btn>
    </v-snackbar>
  </v-form>
</template>

<script>
import axios from "axios";
import { mask } from "vue-the-mask";
import { parse } from "date-fns";
import _ from "lodash";

export default {
  name: "AccessControlForm",
  props: ["initialData"],
  directives: { mask },
  async mounted() {
    this.loading = true;
    this.access = this.initialData;
    this.loading = true;
    this.loadNames();
    this.formattedUnities = Object.keys(this.unities)
      .flatMap(key => {
        if (key !== "labels") {
          const formatted = this.unities[key].map(u => ({
            value: u,
            type: key
          }));
          return formatted;
        }
      })
      .filter(x => x);
    this.type = this.formattedUnities.find(
      fo => fo.value === this.access.unity
    ).type;
  },
  data: () => ({
    access: {
      dateIn: "",
      timeIn: "",
      duration: "",
      unity: "",
      requesterEmail: "",
      managerEmail: "",
      reason: ""
    },
    formattedUnities: [],
    unities: {
      labels: {
        departments: "Département *"
      },
      departments: ["COMEM+", "EC+G", "HEG", "TIC", "TIN"]
    },
    type: "departments",
    searchManagers: null,
    managers: [],
    loading: false,
    submitting: false,
    snackbar: {
      visible: false,
      color: "",
      text: ""
    },
    valid: false,
    validation: {
      dateIn: [
        value => {
          if (value) {
            const parsed = parse(value, "dd.MM.yyyy", new Date());
            if (parsed.toString() !== "Invalid Date" && value.length === 10) {
              return true;
            }
            return "Format attendu JJ.MM.AAAA";
          }
          return true;
        }
      ],
      timeIn: [
        value => {
          if (value) {
            const parsed = parse(value, "HH:mm", new Date());
            if (parsed.toString() !== "Invalid Date" && value.length === 5) {
              return true;
            }
            return "Format attendu HH:MM";
          }
          return true;
        }
      ],
      duration: [
        value => {
          if (value) {
            if (value >= 0 && value <= 24) {
              return true;
            }
            return "La valeur doit être comprise entre 0 et 24";
          }
          return true;
        }
      ]
    }
  }),
  watch: {
    searchManagers: _.debounce(function(val) {
      val &&
        val !== this.access.managerEmail &&
        this.queryPicker(val, "managers");
    }, 300),
    "initialData._id": function(_id) {
      if (_id) {
        this.access = this.initialData;
        this.loadNames();
        this.type = this.formattedUnities.find(
          fo => fo.value === this.access.unity
        ).type;
      }
    }
  },
  methods: {
    async loadNames() {
      const { data: managers } = await axios({
        method: "post",
        url: `${process.env.VUE_APP_PEOPLEPICKER_URI}/users`,
        data: [this.access.managerEmail],
        headers: {
          "x-api-key": process.env.VUE_APP_PEOPLEPICKER_KEY
        }
      });
      this.managers = managers;
    },
    async queryPicker(v, key) {
      this.loading = true;
      const { data: contacts } = await axios({
        method: "get",
        url: `${process.env.VUE_APP_PEOPLEPICKER_URI}/search?s=${v}`,
        headers: {
          "x-api-key": process.env.VUE_APP_PEOPLEPICKER_KEY
        }
      });
      contacts.map(c =>
        this[key].push({
          text: `${c.firstname} ${c.lastname}`,
          value: c.email
        })
      );
      this[key] = _.uniqBy(this[key], "value");
      this.loading = false;
    },
    clearSearchManagers() {
      this.searchManagers = null;
    }
  },
  computed: {
    requiredFields: function() {
      return (
        !!this.access.dateIn &&
        !!this.access.timeIn &&
        !!this.access.duration &&
        !!this.access.unity &&
        !!this.access.requesterEmail &&
        !!this.access.managerEmail &&
        !!this.access.reason
      );
    }
  }
};
</script>